import { Meta } from '@/data/Meta';
import { createContext, useContext } from 'react';

export type PageBlockMeta = Meta & {
	pageIdentifier?: string;
	pageId?: string;
	pageGroup?: string;
	tokenName?: string;
	tokenExternalValue?: string;
};

export type PageBlockContext = {
	meta: PageBlockMeta;
};

export const PageBlockContext = createContext<PageBlockContext>({} as PageBlockContext);
export const PageBlockProvider = PageBlockContext.Provider;

export const usePageBlock = () => {
	const context = useContext(PageBlockContext);
	if (!context) {
		throw new Error('usePageBlock must be used within a PageBlockProvider');
	}
	return context;
};
